export class Tokens {
    function: string = "";
    permissions: any[];
}

